export const SIGNING_COMING_SOON = 'signingComingSoon';
export const SIGNING_OUT_OF_STOCK = 'signingOutOfStock';
export const SIGNING_SOLD_OUT_LOWERCASE = 'soldout';
